module.exports = __webpack_public_path__ + "img/func_3_4.861e2d02.svg";